<template>
  <!--  'text-text-primary': !active, 'text-white':color === 'primary I need to added this pops here because of notification button got selected when organizations change submit -->
  <div :style="boundingBoxStyle"
       class="flex items-center justify-center"
       :class="{ 'text-text-primary': !active, 'text-white':color === 'primary'}">
    <font-awesome-icon v-if="computedIcon"
                       :icon="computedIcon"
                       :style="boundingBoxStyle"
                       :spin="spin"/>
    <slot name="icon"/>
  </div>
</template>

<script setup lang="ts">
import type {PropType} from "vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {iconProp, useIconProp} from "~/components/global/utils/iconPropUtil";

const props = defineProps({
  ...iconProp,

  boundingBox: {
    // Bounding box could be a number, or an array of numbers like [width, height]
    type: [Number, Array] as PropType<number | number[]>,
    required: true,
    validator: (value: unknown) => {
      if (typeof value === 'number') {
        return true;
      } else if (Array.isArray(value) && value.length === 2) {
        return true;
      }

      return false;
    },
  },
  spin: {
    type: Boolean,
    default: false,
    required: false,
  },
  active: {
    type: Boolean,
    required: false,
    default: true
  },
  color:{
    type:String,
    required:false,
    default:''
  }
});

const {computedIcon} = useIconProp(props);

const boundingBoxStyle = computed(() => {
  if (typeof props.boundingBox === 'number') {
    return {
      width: `${props.boundingBox}px`,
      height: `${props.boundingBox}px`,
    };
  } else if (Array.isArray(props.boundingBox) && props.boundingBox.length === 2) {
    return {
      width: `${props.boundingBox[0]}px`,
      height: `${props.boundingBox[1]}px`,
    };
  }

  return {};
});
</script>